import type { HostAdapter } from "../core/types.js";

export const officeHost: HostAdapter = {
  name: "office-word",
  version: getOfficeVersion(),
  async getSelectionText() {
    if (typeof Word === "undefined") {
      throw new Error("Office Word API is not available.");
    }

    return Word.run(async (context) => {
      const selection = context.document.getSelection();
      selection.load("text");
      await context.sync();
      return selection.text || "";
    });
  },
  async getDocumentText() {
    if (typeof Word === "undefined") {
      throw new Error("Office Word API is not available.");
    }

    return Word.run(async (context) => {
      const body = context.document.body;
      body.load("text");
      await context.sync();
      return body.text || "";
    });
  },
  supportsSelection() {
    return true;
  }
};

function getOfficeVersion(): string {
  if (typeof Office !== "undefined") {
    return Office.context?.diagnostics?.version || "unknown";
  }

  return "unknown";
}
